import { render, staticRenderFns } from "./myaddress.vue?vue&type=template&id=7e94f39b&scoped=true&"
import script from "./myaddress.vue?vue&type=script&lang=js&"
export * from "./myaddress.vue?vue&type=script&lang=js&"
import style0 from "./myaddress.vue?vue&type=style&index=0&id=7e94f39b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e94f39b",
  null
  
)

export default component.exports